export const backgroundList = [
  "rgba(255,255,255,1)",
  "rgba(44,47,49,1)",
  "rgba(233, 216, 188,1)",
  "rgba(197, 231, 207,1)",
];
export const textList = [
  "rgba(0,0,0,1)",
  "rgba(255,255,255,1)",
  "rgba(89, 68, 41,1)",
  "rgba(54, 80, 62,1)",
];
export const themeList = [
  { id: 0, color: "default", title: "Default" },
  { id: 1, color: "#0179CA", title: "Blue" },
  { id: 2, color: "#008F91", title: "Green" },
  { id: 3, color: "#F16464", title: "Red" },
  { id: 4, color: "#6867D1", title: "Purple" },
  { id: 5, color: "#F97316", title: "Orange" },
  { id: 6, color: "#EC4899", title: "Pink" },
  { id: 7, color: "#EAB308", title: "Yellow" },
  { id: 8, color: "#8B5CF6", title: "Violet" },
  { id: 9, color: "#0EA5E9", title: "Sky" },
  { id: 10, color: "#64748B", title: "Slate" },
];
export const classes = [
  "color-0",
  "color-1",
  "color-2",
  "color-3",
  "line-0",
  "line-1",
  "line-2",
  "line-3",
];
export const colors = ["#FEF3CD", "#FBFACC", "#CEFACD", "#CDE9FA"];
export const lines = ["#FF0000", "#000080", "#0000FF", "#2EFF2E"];
